import * as React from "react";
import InputForm from "./InputForm";
import FormContainer from "./FormContainer";

interface props {
  onChange?: ((email: string) => void);
}

class EmailInputForm extends React.Component<props, any> {
  render() {
    return (
      <FormContainer>
        <InputForm
          InputTitleText="Email"
          InputPlaceholderText="amy.g@upenn.edu"
          onChange={value => this.props.onChange && this.props.onChange(value)}
        />
      </FormContainer>
    );
  }
}

export default EmailInputForm;



// WEBPACK FOOTER //
// ./src/components/FormComponents/EmailInputForm.tsx